export const Cor = {
  cinzaEscuro: "#42474a",
  verde: "#297805",
  laranja: "#FF7A00",
  vermelho: "#b40c02",
};
